import {
  HomeIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import { dashboardState } from "../../redux/reducers/dashboardReducer";

import { BuildingOfficeIcon, CalendarDaysIcon, CreditCardIcon, EyeIcon, EyeSlashIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid';
import charetleft from "../../assets/charetleft.svg";
import lock_img from "../../assets/password.svg";
import { TwButton, TwCalendarPicker, TwCheckBox, TwContainer, TwDropzone, TwInputGroup, TwLocationInput, TwMainLayout, TwPhoneInputGroup, TwRadioBox, TwSelectGroup, TwSwitch, TwTabContainer, TwTimePicker } from '../../components/tailwind';
import { useToast } from "../../provider/ToastProvider";
import { userState } from "../../redux/reducers/userReducer";

export default function TwTest() {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const [userToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [loading, setLoading] = React.useState(false);
  const [formErrors, setFormErrors] = React.useState({ venueAddress: "Please enter venue address", gender: "Please select gender", calendar: "Please select calendar" });
  const [passwordVisible, setPasswordVisible] = React.useState(false);


  const onBackClick = () => {
    navigate("/myclasses", { replace: true });
  };

  const secondaryNavigation = [
    { name: 'Overview', href: '#', current: true },
    { name: 'Activity', href: '#', current: false },
    { name: 'Settings', href: '#', current: false },
    { name: 'Collaborators', href: '#', current: false },
    { name: 'Notifications', href: '#', current: false },
  ]
  const stats = [
    { name: 'Number of deploys', value: '405' },
    { name: 'Average deploy time', value: '3.65', unit: 'mins' },
    { name: 'Number of servers', value: '3' },
    { name: 'Success rate', value: '98.5%' },
  ]
  const statuses = { Completed: 'text-green-400 bg-green-400/10', Error: 'text-rose-400 bg-rose-400/10' }
  const activityItems = [
    {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    }, {
      user: {
        name: 'Michael Foster',
        imageUrl:
          'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      commit: '2d89f0c8',
      branch: 'main',
      status: 'Completed',
      duration: '25s',
      date: '45 minutes ago',
      dateTime: '2023-01-23T11:00',
    },
    // More items...
  ]

  return (
    <TwMainLayout
      checkSession={false}
      showHeader={true}
      loading={loading}
      headTitle="Dashboard"
      breadcrumbs={[
        { title: "My Services", onClick: () => { alert("My Services") } },
        { title: "Services Detail", onClick: () => { alert("Services Detail") } },
        { title: "Add New Services", onClick: () => { alert("Add New Services") } },
      ]}
      headActions={[
        (<TwButton
          variant=""
          className="w-full min-w-20"
        // className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50"
        >
          default
        </TwButton>),
        (<TwButton
          variant="brown-coffee"
          className="w-full"
        >
          brown-coffee
        </TwButton>),
        (<TwButton
          variant="brown-coffee-outline"
          className="w-full"
        >
          brown-coffee-outline
        </TwButton>),
        (<TwButton
          variant="orange"
          className="w-full"
        >
          orange
        </TwButton>),
        (<TwButton
          variant="orange-outline"
          className="w-full"
        >
          orange-outline
        </TwButton>),
      ]}
      footerActions={[
        (<TwButton
          variant="orange-outline"
        >
          Back
        </TwButton>),
        (<TwButton
          variant="brown-coffee"
        >
          Continue
        </TwButton>),
      ]}
      navBarTitleComp={
        <h3 className={"font-extrabold text-2xl text-brown-coffee content-center"}>
          <img src={charetleft} alt="" className="inline align-baseline mr-8 cursor-pointer" onClick={() => {
            onBackClick();
          }} />Dashboard
        </h3>
      }
      children={
        <TwContainer>
          <TwTabContainer
            tabs={[
              { name: 'My Account', key: 'myAccount', onClick: () => { }, icon: UserIcon, tabPanelComponent: (<>My Account Content</>) },
              { name: 'Company', key: 'company', onClick: () => { }, icon: BuildingOfficeIcon, tabPanelComponent: (<>Company</>) },
              { name: 'Team Members', onClick: () => { }, icon: UsersIcon, tabPanelComponent: (<>Team Members</>) },
              { name: 'Billing', onClick: () => { }, icon: CreditCardIcon, tabPanelComponent: (<>Billing</>) },
            ]}
          />
          <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
            <div className="flex flex-col gap-5 1sm:mx-auto sm:w-full sm:max-w-sm md:max-w-lg">
              <TwDropzone
                label={"profile Image"}
                variant={"profile"}
                name={"venueName"}
                // value={"https://www.voorburgcc.nl/wp-content/uploads/Clubfoto-2022-bewerkt_MSt-2048x875.avif"}
                errors={formErrors}
                onChange={(image) => {
                  console.log("image", image);

                }}
              />
              <TwDropzone
                label={"file Image"}
                variant={"formData"}
                name={"venueName"}
                // value={"https://www.voorburgcc.nl/wp-content/uploads/Clubfoto-2022-bewerkt_MSt-2048x875.avif"}
                errors={formErrors}
                onChange={(image) => {
                  console.log("image", image);

                }}
              />
              <TwDropzone
                label={"Article Image"}
                name={"venueName"}
                value={"https://www.voorburgcc.nl/wp-content/uploads/Clubfoto-2022-bewerkt_MSt-2048x875.avif"}
                errors={formErrors}
                onChange={(image) => {
                  console.log("image", image);

                }}
              />


              <TwInputGroup
                label={"Venue Name"}
                name={"venueName"}
                leftIcon={(<HomeIcon className="size-5 sm:size-4" />)}
                errors={formErrors}
              // error={formErrors?.venueName}
              />
              <TwLocationInput
                label={"Venue Address"}
                name={"venueAddress"}
                leftIcon={(<MapPinIcon className="size-5 sm:size-4" />)}
                errors={formErrors}
              // error={formErrors?.venueName}
              />
              <TwPhoneInputGroup
                label={"Business Number"}
                placeholder={"Phone Number"}
                name={"workNumber"}
                onChange={(phone, country, e) => {
                  const numberWithoutDialCode = phone.split("");
                  for (let i = 0; i < country.dialCode.length; i++) {
                    numberWithoutDialCode.shift();
                  }
                  let dialCode = country.dialCode;
                  if (
                    country.format.includes("+") &&
                    !country.dialCode.includes("+")
                  ) {
                    dialCode = "+".concat(country.dialCode);
                  }
                  console.log("countryName", country.countryCode);
                  console.log("countryCode", dialCode);
                  console.log("phone", numberWithoutDialCode.join(""));
                  console.log("formattedPhoneNumber", e.target.value);
                }}
              />
              <TwInputGroup
                label={"Venue Address"}
                name={"venueAddress"}
                leftIcon={(<HomeIcon className="size-5 sm:size-4" />)}
                errors={formErrors}
              // error={formErrors?.venueName}
              />
              <TwSelectGroup label={"Gender"}
                placeholder={"Select Gender"}
                name={"gender"}
                leftIcon={(<HomeIcon className="size-5 sm:size-4" />)}
                options={[
                  { value: "", title: "Select Gender" },
                  { value: "Male", title: "Male" },
                  { value: "Female", title: "Female" },
                  { value: "Other", title: "Other" },
                ]}
                errors={formErrors} />
              <TwRadioBox label={"Gender"}
                title={"Select Gender"}
                subTitle={"Select Gender at list one"}
                name={"gender"}
                displayStyle="inline-list"
                value="female"
                onChange={(e) => {
                  console.log("Radio change", e.target.value);
                  // console.log("time change toDate", date.toDate());
                  // console.log("time change time", date.format("HH:mm"));
                }}
                radioList={[
                  { id: 'Male', value: 'male', title: 'Male' },
                  { id: 'Female', value: 'female', title: 'Female' },
                  { id: 'Other', value: 'other', title: 'Other' },
                ]}
                errors={formErrors} />
              <TwCheckBox label={"Gender"}
                title={"Select Gender"}
                subTitle={"Select Gender at list one"}
                name={"gender"}
                errors={formErrors} />
              <TwSwitch
                label={"Gender"}
                name={"gender"}
                errors={formErrors} />
              <TwCalendarPicker
                label={"Calendar"}
                name={"calendar"}
                leftIcon={(<CalendarDaysIcon className="size-5 sm:size-4" />)}
                // multiple
                range
                dateSeparator=" to "
                numberOfMonths={2}
                format="D-MMM-YYYY"
                errors={formErrors} />
              <TwTimePicker
                label={"Time"}
                name={"calendar"}
                leftIcon={(<CalendarDaysIcon className="size-5 sm:size-4" />)}
                onChange={(date, dateParams) => {
                  // console.log("time change", { date, dateParams });
                  // console.log("time change toDate", date.toDate());
                  // console.log("time change time", date.format("HH:mm"));
                }}
                errors={formErrors} />
              <TwInputGroup
                label={"Password"}
                placeholder={"Enter Password"}
                name={"password"}
                type={passwordVisible ? "text" : "password"}
                leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                rightIcon={
                  passwordVisible ? (
                    <EyeIcon onClick={() => setPasswordVisible(!passwordVisible)} />
                  ) : (
                    <EyeSlashIcon onClick={() => setPasswordVisible(!passwordVisible)} />
                  )
                }
                // onChange={handleInputChange}
                errors={formErrors}
              />
              <TwInputGroup
                label={"Venue Address"}
                name={"venueAddress"}
                leftIcon={(<HomeIcon className="size-5 sm:size-4" />)}
                errors={formErrors}
              // error={formErrors?.venueName}
              />
              <TwInputGroup
                label={"Venue Address"}
                name={"venueAddress"}
                leftIcon={(<HomeIcon className="size-5 sm:size-4" />)}
                errors={formErrors}
              // error={formErrors?.venueName}
              />
            </div>
          </div>
        </TwContainer>
      } />
  );
}
